import misRutas from 'vue-routes-generator'
import MainComponent from './main.component'
import OverView from './components/overview/mainOverview.component'

export default {
	install: Vue => {
		misRutas.route('/main').child('produccion-audiovisual', {
			name: 'Producción',
			component: MainComponent
		})

		misRutas.route('/main').child('produccion-audiovisual').child('', {
			name: 'Vista rápida',
			component: OverView
		})

		misRutas.route('/main').child('produccion-audiovisual').child('tarea/:TareaID', {
			name: 'Tarea',
			component: OverView
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/produccion-audiovisual/vue/index.js